export const contactTranslations = {
    en: {
        pageTitle: "Contact Us",
        pageSubtitle: "Get in touch with our expert investigation team",
        infoTitle: "Contact Our Registered Office",
        headings: {
            pi: "Principal Investigator",
            address: "📍 Address",
            mobile: "📞 Mobile",
            email: "✉️ Email"
        },
        address: {
            line1: "Cabin No. 1, 3rd Floor, SCO 15",
            line2: "World 1 High Street Shop",
            line3: "Sector 111, Kharar-Landran Road",
            line4: "Mohali, Punjab — 140307"
        },
        quote: "\"Investigating with diligence, delivering with integrity.\"",
        badges: [
            "Active Since 2007",
            "IBNR–FFRM Since 2022",
            "Punjab & Haryana Coverage"
        ],
        formTitle: "Request Investigation",
        formSubtitle: "Fill out the form and we'll get back to you shortly",
        formLabels: {
            name: "Full Name *",
            email: "Email Address *",
            phone: "Phone Number *",
            company: "Company / Organization",
            message: "Message / Investigation Details *",
            submit: "Submit Request"
        },
        placeholders: {
            name: "Enter your full name",
            email: "your.email@example.com",
            phone: "+91-XXXXXXXXXX",
            company: "Your company name",
            message: "Please provide details about your investigation requirements..."
        },
        alert: "Thank you for your inquiry! We will contact you soon."
    },
    hi: {
        pageTitle: "संपर्क करें",
        pageSubtitle: "हमारी विशेषज्ञ जांच टीम से संपर्क करें",
        infoTitle: "हमारे पंजीकृत कार्यालय से संपर्क करें",
        headings: {
            pi: "प्रधान अन्वेषक",
            address: "📍 पता",
            mobile: "📞 मोबाइल",
            email: "✉️ ईमेल"
        },
        address: {
            line1: "केबिन नंबर 1, तीसरी मंजिल, SCO 15",
            line2: "वर्ल्ड 1 हाई स्ट्रीट शॉप",
            line3: "सेक्टर 111, खरड़-लांडरां रोड",
            line4: "मोहाली, पंजाब — 140307"
        },
        quote: "\"परिश्रम के साथ जांच, ईमानदारी के साथ वितरण।\"",
        badges: [
            "2007 से सक्रिय",
            "2022 से IBNR-FFRM",
            "पंजाब और हरियाणा कवरेज"
        ],
        formTitle: "जांच का अनुरोध करें",
        formSubtitle: "फॉर्म भरें और हम आपसे जल्द ही संपर्क करेंगे",
        formLabels: {
            name: "पूरा नाम *",
            email: "ईमेल पता *",
            phone: "फ़ोन नंबर *",
            company: "कंपनी / संगठन",
            message: "सदेश / जांच विवरण *",
            submit: "अनुरोध जमा करें"
        },
        placeholders: {
            name: "अपना पूरा नाम दर्ज करें",
            email: "आपका ईमेल",
            phone: "+91-XXXXXXXXXX",
            company: "आपकी कंपनी का नाम",
            message: "कृपया अपनी जांच आवश्यकताओं के बारे में विवरण प्रदान करें..."
        },
        alert: "आपकी पूछताछ के लिए धन्यवाद! हम आपसे जल्द ही संपर्क करेंगे।"
    },
    pa: {
        pageTitle: "ਸੰਪਰਕ ਕਰੋ",
        pageSubtitle: "ਸਾਡੀ ਮਾਹਰ ਜਾਂਚ ਟੀਮ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
        infoTitle: "ਸਾਡੇ ਰਜਿਸਟਰਡ ਦਫਤਰ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
        headings: {
            pi: "ਪ੍ਰਿੰਸੀਪਲ ਇਨਵੈਸਟੀਗੇਟਰ",
            address: "📍 ਪਤਾ",
            mobile: "📞 ਮੋਬਾਈਲ",
            email: "✉️ ਈਮੇਲ"
        },
        address: {
            line1: "ਕੈਬਿਨ ਨੰਬਰ 1, ਤੀਜੀ ਮੰਜ਼ਿਲ, SCO 15",
            line2: "ਵਰਲਡ 1 ਹਾਈ ਸਟ੍ਰੀਟ ਸ਼ਾਪ",
            line3: "ਸੈਕਟਰ 111, ਖਰੜ-ਲਾਂਡਰਾਂ ਰੋਡ",
            line4: "ਮੋਹਾਲੀ, ਪੰਜਾਬ — 140307"
        },
        quote: "\"ਮਿਹਨਤ ਨਾਲ ਜਾਂਚ, ਇਮਾਨਦਾਰੀ ਨਾਲ ਸਪੁਰਦਗੀ।\"",
        badges: [
            "2007 ਤੋਂ ਸਰਗਰਮ",
            "2022 ਤੋਂ IBNR-FFRM",
            "ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਕਵਰੇਜ"
        ],
        formTitle: "ਜਾਂਚ ਦੀ ਬੇਨਤੀ ਕਰੋ",
        formSubtitle: "ਫਾਰਮ ਭਰੋ ਅਤੇ ਅਸੀਂ ਜਲਦੀ ਹੀ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਾਂਗੇ",
        formLabels: {
            name: "ਪੂਰਾ ਨਾਮ *",
            email: "ਈਮੇਲ ਪਤਾ *",
            phone: "ਫੋਨ ਨੰਬਰ *",
            company: "ਕੰਪਨੀ / ਸੰਗਠਨ",
            message: "ਸੁਨੇਹਾ / ਜਾਂਚ ਵੇਰਵੇ *",
            submit: "ਬੇਨਤੀ ਜਮ੍ਹਾਂ ਕਰੋ"
        },
        placeholders: {
            name: "ਆਪਣਾ ਪੂਰਾ ਨਾਮ ਦਰਜ ਕਰੋ",
            email: "ਤੁਹਾਡਾ ਈਮੇਲ",
            phone: "+91-XXXXXXXXXX",
            company: "ਤੁਹਾਡੀ ਕੰਪਨੀ ਦਾ ਨਾਮ",
            message: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀਆਂ ਜਾਂਚ ਲੋੜਾਂ ਬਾਰੇ ਵੇਰਵੇ ਪ੍ਰਦਾਨ ਕਰੋ..."
        },
        alert: "ਤੁਹਾਡੀ ਪੁੱਛਗਿੱਛ ਲਈ ਧੰਨਵਾਦ! ਅਸੀਂ ਜਲਦੀ ਹੀ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਾਂਗੇ।"
    }
};
